module.exports = __webpack_public_path__ + "static/media/male-eating.5305985a.svg";